export interface SignInError {
  code: string;
  message?: string | null;
}

export type SignInRecoveryAction = 'requestMagicLink';

export interface SignInRecovery {
  action: SignInRecoveryAction;
  label: string;
}

export interface SignInErrorFailure {
  kind: 'error';
  message: string;
}

export interface ConfirmationRequiredFailure {
  kind: 'confirmationRequired';
  heading: string;
  message: string;
  hint: string;
  recovery: SignInRecovery;
}

export type SignInFailure = SignInErrorFailure | ConfirmationRequiredFailure;

export const GENERIC_SIGN_IN_FAILURE: SignInFailure = {
  kind: 'error',
  message: "We couldn't sign you in. Try again in a moment.",
};

function confirmationRequired(email: string): ConfirmationRequiredFailure {
  return {
    kind: 'confirmationRequired',
    heading: 'Confirm your email to sign in',
    message: `Check ${email} for a confirmation link. Open it, then sign in here.`,
    hint: 'Not there after a few minutes? Check your spam folder.',
    recovery: { action: 'requestMagicLink', label: 'Email me a sign-in link instead' },
  };
}

export function describeSignInFailure(error: SignInError | null | undefined, email: string): SignInFailure {
  switch (error?.code) {
    case 'invalid_credentials':
      return { kind: 'error', message: 'Incorrect email or password.' };
    case 'user_banned':
      return { kind: 'error', message: error.message || 'User is banned' };
    case 'unconfirmed_email':
      return confirmationRequired(email);
    default:
      return GENERIC_SIGN_IN_FAILURE;
  }
}
